export function getTimeOptions(day: Date): Date[] {
  const timeOptions = [];
  const currentDateTime = new Date();
  let hour = 0;
  if (currentDateTime.getDate() == day.getDate()) {
    if (currentDateTime.getMinutes() <= 30) {
      timeOptions.push(new Date(day.getFullYear(), day.getMonth(), day.getDate(), currentDateTime.getHours(), 30, 0));
    }
    hour = currentDateTime.getHours() + 1;
  }

  for (; hour < 24; hour++) {
    timeOptions.push(
      new Date(day.getFullYear(), day.getMonth(), day.getDate(), hour, 0, 0),
      new Date(day.getFullYear(), day.getMonth(), day.getDate(), hour, 30, 0),
    );
  }
  return timeOptions;
}
